import Api from "..";
import PrivateUser from "../../dtos/user";
import { UserRegisterInput } from "../../dtos/user/input";
import { UserOtpResponse } from "../../dtos/user/otp";
import transform from "../../service/transform";

export default class UserApi extends Api {
  constructor() {
    super("user/user");
  }

  public async post(data: UserRegisterInput): Promise<UserOtpResponse> {
    return await transform(UserOtpResponse)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: UserRegisterInput
  ): Promise<UserOtpResponse | PrivateUser> {
    const value = (await super.put(id, data)).data;
    try {
      return await transform(PrivateUser)(value);
    } catch {
      return await transform(UserOtpResponse)(value);
    }
  }

  public async delete(id: string): Promise<PrivateUser> {
    return await transform(PrivateUser)((await super.delete(id)).data);
  }
}
